import { IInventoryTemplateDetail } from './IInventoryTemplateDetail';
import { IInventoryTemplateEquipment } from './IInventoryTemplateEquipment';

export interface IInventoryTemplate {
  inventoryTemplateId: string;
  inventoryTemplateName: string;
  equipmentTypeId: string;
  note: string;
  inventoryTemplateEquipments: IInventoryTemplateEquipment[];
  inventoryTemplateDetails: IInventoryTemplateDetail[];
  isActive: boolean;
  isUserCreated: boolean;
}
